<template>
    <div>
        <span class="border-t border-gray-darker"></span>
        <component
            :is="makers[type]"
            :spell="spell"
            @change="$emit('change', $event)"
        ></component>
    </div>
</template>

<script>
import FolderSpellMaker from "./FolderSpellMaker";
import ForwardSpellMaker from "./ForwardSpellMaker";
import MagazineSpellMaker from "./MagazineSpellMaker";
import ReplySpellMaker from "./ReplySpellMaker";

export default {
    props: {
        type: {
            type: String,
            required: true,
        },
        spell: {
            type: Object,
            default: null,
        },
    },
    data() {
        return {
            makers: {
                "spell.magazine": MagazineSpellMaker,
                "spell.reply": ReplySpellMaker,
                "spell.forward": ForwardSpellMaker,
                "spell.folder": FolderSpellMaker,
            },
        };
    },
};
</script>

<style></style>
